import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { store } from "./store";
import Home from "./components/ExhibitorList";
import DetailPage from "./components/ExhibitorProfile/ExhibitorProfile";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/conferences/strategic-conference/strategic-speakers/",
    component: Home
  },
  {
    name: "home",
    path: "/conference/technical-conference/technical-speakers/",
    component: Home
  },
  {
    name: "home",
    path: "/conference/strategic-summit/strategic-speakers/",
    component: Home
  },
  {
    name: "home",
    path: "/conference/strategic-summit/fma-strategic-speakers/",
    component: Home
  },
  {
    name: "home",
    path: "/conference/technical-conference/fma-technical-speakers/",
    component: Home
  },
  {
    //for fma
    name: "home",
    path: "/conference-and-networking/strategic-summit/strategic-speakers/",
    component: Home
  },
  {
    name: "home",
    path: "/conference-and-networking/technical-conference/technical-conference-speakers/",
    component: Home
  },
  //for japan
  {
    name: "home",
    path: "/conferences/technical-conference/technical-speakers-2024/",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/strategic-conference/strategic-speakers-2024/",
    component: Home
  },
  {
    name: "SpeakerDetails",
    path: "/speakerdetails",
    component: DetailPage
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
